import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../../_mexablock/layout/core';
import { View } from './components/View';

const breadCrumbs: Array<PageLink> = [
  {
    title: 'Reportes',
    path: '/reportes/suspensiones',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];

const ReporteSuspensionesPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Suspensiones</PageTitle>
      <View />
    </>
  );
};

export { ReporteSuspensionesPage };
